"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const arrowdown = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-arrowdown` : '') + (description ? ` desc-arrowdown` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-arrowdown"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-arrowdown"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.8894 0.756293C11.4176 0.810327 11.05 1.20577 11.05 1.6875V20.057L2.87016 12.023L2.77814 11.9441C2.38856 11.6594 1.8636 11.6952 1.52985 12.023C1.15672 12.3895 1.15672 12.9855 1.52985 13.352L11.3298 22.977C11.3617 23.0083 11.3951 23.0367 11.4345 23.0659L11.5313 23.1276L11.6217 23.1724L11.7493 23.2164L11.808 23.2307L11.9132 23.2458L11.9908 23.2498C12.0943 23.2498 12.1872 23.2364 12.2755 23.2099L12.389 23.1675L12.5046 23.1065C12.5733 23.0629 12.6238 23.0225 12.6702 22.977L22.4702 13.352L22.5505 13.2616C22.8431 12.8754 22.8061 12.353 22.4702 12.023L22.3781 11.9441L22.2688 11.8744C21.8947 11.6683 21.4333 11.725 21.1298 12.023L12.95 20.055V1.6875L12.943 1.57713C12.8773 1.09725 12.4757 0.75 12 0.75L11.8894 0.756293Z",
    fill: "inherit"
  }));
};
var _default = exports.default = arrowdown;